import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class TraduccionesInstitucionService {

  constructor(
    private http: HttpClient,
    private translate: TranslateService,
  ) {}

  async configurar(
    idioma: string,
    institucionId: string
  ): Promise<void> {

    this.translate.setDefaultLang(idioma);

    await this.cargarExcepciones(
      idioma,
      institucionId
    );

    await firstValueFrom(
      this.translate.use(idioma)
    );
  }

  async cargarExcepciones(
    idioma: string,
    institucionId: string
  ){
    try {
      const ruta = 
      `assets/i18n/instituciones/${institucionId}.json`;

      const traducciones = await firstValueFrom(
        this.http.get<Record<string, any>>(ruta)
      );

      this.translate.setTranslation(
        idioma,
        traducciones,
        true
      );
    } catch (error) {
    }
  }
}
